import { HeaderPage } from '@/Core/UI/HeaderPage'
import { List } from '@/Core/UI/List'
import { observer } from 'mobx-react-lite'
import { Filter } from '../Components/Filter'
import type { CrudResourceStore } from '../Stores/CrudResourceStore'
import type { ReactNode } from 'react'

interface CrudResourceTemplateProps {
    crudContext: CrudResourceStore
}

interface FilterObserverProps {
    children: ReactNode
}

export const CrudResourceTemplate = ({ crudContext }: CrudResourceTemplateProps) => {
    const FilterObserver = observer(({ children }: FilterObserverProps) => {
        if (!crudContext.isFilter) return null

        const variant = crudContext.listContext?.variant
        const variantItems = crudContext.listContext?.variantItems ?? {}
        const currentVariantItem = variantItems[variant]
        if (variant && currentVariantItem?.hasFilter === false) return null

        return (
            <div
                width={300}
            >
                {children}
            </div>
        )
    })
    
    return (
        <div
            style={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <HeaderPage headerPageContext={crudContext.headerPageContext} />
            <div className="wl-content-wrapper">
                <FilterObserver>
                    <Filter />
                </FilterObserver>
                <List listContext={crudContext.listContext} />
            </div>
        </div>
    )
}
